import moment from 'moment'

function getEaster(year: number): moment.Moment {
  const lunarCycle = year % 19
  const century = Math.floor(year / 100)
  const yearInCentury = year % 100
  const leapCenturyCorrection = Math.floor(century / 4)
  const leapCenturyRemainder = century % 4
  const solarCorrection = Math.floor((century + 8) / 25)
  const lunarCorrection = Math.floor((century - solarCorrection + 1) / 3)
  const paschalFullMoon =
    (19 * lunarCycle + century - leapCenturyCorrection - lunarCorrection + 15) % 30
  const leapYearCorrection = Math.floor(yearInCentury / 4)
  const leapYearRemainder = yearInCentury % 4
  const sundayOffset =
    (32 + 2 * leapCenturyRemainder + 2 * leapYearCorrection - paschalFullMoon - leapYearRemainder) % 7
  const lunarLeapCorrection =
    Math.floor((lunarCycle + 11 * paschalFullMoon + 22 * sundayOffset) / 451)
  const month = Math.floor((paschalFullMoon + sundayOffset - 7 * lunarLeapCorrection + 114) / 31)
  const day = ((paschalFullMoon + sundayOffset - 7 * lunarLeapCorrection + 114) % 31) + 1
  return moment({ year, month: month - 1, day })
}

export function getFrenchHolidays(year: number): Record<string, string> {
  const easter = getEaster(year)
  return {
    [`${year}-01-01`]: 'Jour de l\'An',
    [`${year}-05-01`]: 'Fête du Travail',
    [`${year}-05-08`]: 'Victoire 1945',
    [`${year}-07-14`]: 'Fête Nationale',
    [`${year}-08-15`]: 'Assomption',
    [`${year}-11-01`]: 'Toussaint',
    [`${year}-11-11`]: 'Armistice',
    [`${year}-12-25`]: 'Noël',
    [easter.clone().add(1, 'day').format('YYYY-MM-DD')]: 'Lundi de Pâques',
    [easter.clone().add(39, 'days').format('YYYY-MM-DD')]: 'Ascension',
    [easter.clone().add(50, 'days').format('YYYY-MM-DD')]: 'Lundi de Pentecôte',
  }
}

export const humanizeDurationSeconds = (seconds?: number | null) => { 
  if (!seconds || seconds < 60) {
    return null
  }
  const d = moment.duration(seconds, 'seconds')
  const hours = Math.floor(d.asHours())
  const minutes = d.minutes()
  const secs = d.seconds()
  if (hours > 0) {
    if (secs > 0) {
      return `${hours} h ${minutes} min ${secs} s`
    }
    return (minutes > 0) ? `${hours} h ${minutes} min` : `${hours} h`
  }
  return secs > 0 ? `${minutes} min ${secs} s` : `${minutes} min`
}
